import { onICalendarFeedActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ICalendarFeedActivityCard } from "./ICalendarFeedActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  iCalendarFeedId: number
  config: server.dto.ActivityPanelConfig
}

export const ICalendarFeedActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.ICalendarFeedActivity>
    noMarginTop
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ICalendarFeed.ListActivity({ itemId: props.iCalendarFeedId, page, perPage })}
    renderActivity={(activity => <ICalendarFeedActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onICalendarFeedActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.iCalendarFeedId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}